import { SessionStorage } from "../../lib";

export default function getToken(response) {
  const token = response.data.token;
  SessionStorage.setItem("token", token);

  return response;
}
